module.exports = __webpack_public_path__ + "img/Hero-Banner@2x.268d16cc.jpg";